var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: { title: _vm.title, width: "900px", height: "600px", top: "10vh" },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _vm.visible
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "choose_resource",
            },
            [
              _c(
                "el-tabs",
                {
                  staticStyle: { height: "100%" },
                  attrs: { "tab-position": "left", type: "border-card" },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "按专栏" } },
                    [
                      _c("column", {
                        attrs: { "column-disabled-fn": _vm.columnDisabledFn },
                        on: { sureColumn: _vm.sureColumn },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "按用户" } },
                    [
                      _c("user", {
                        attrs: { "user-disabled-fn": _vm.userDisabledFn },
                        on: {
                          successData: _vm.userDataFn,
                          successObj: _vm.userSearchFn,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }